/**
 * Format lot asking/sale price for display. Prefers the descriptive string
 * from the API when present, otherwise formats the numeric value.
 */
export function formatLotPrice(
  price: number | null | undefined,
  desc?: string | null,
): string {
  const trimmedDesc = desc?.trim();
  if (trimmedDesc) return trimmedDesc;
  if (price == null || Number.isNaN(price)) return '';
  return price.toLocaleString('en-AU');
}
